import PropTypes from "prop-types";

import { TableCell, TableRow, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import StatusChip from "src/components/StatusChip";

// ----------------------------------------------------------------------

StudentTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
  onEditRow: PropTypes.func,
  onViewRow: PropTypes.func,
};

export default function StudentTableRow({
  row,
  selected,
  onViewRow,
  onEditRow,
}) {
  const displayName =
    `${row.first_name || ""} ${row.last_name || ""}`.trim() || "-";

  const sessionInfo =
    `${row.session_type || ""} ${row.session_value || ""}`.trim() || "-";

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell align="left">
          <Link
            color="inherit"
            variant="subtitle2"
            onClick={(e) => {
              onViewRow(row.id);
            }}
            sx={{ cursor: "pointer" }}
          >
            {displayName}
          </Link>
        </TableCell>
        <TableCell align="left">
          <Typography noWrap>{row.email ?? "-"}</Typography>
        </TableCell>

        <TableCell align="left" sx={{ textTransform: "capitalize" }}>
          {(row.date_of_birth != "" ? row.date_of_birth : null) ?? "-"}
        </TableCell>
        <TableCell align="left">{row.age > 0 ? row.age : "-"}</TableCell>
        <TableCell align="left">{sessionInfo ?? "-"}</TableCell>
        <TableCell align="left">
          <StatusChip status={row.status ?? "-"} />
        </TableCell>
      </TableRow>
    </>
  );
}
